import { IonIcon, IonRouterLink, IonText } from '@ionic/react';
import { helpCircleOutline } from 'ionicons/icons';
import { CSSProperties, ReactElement, ReactNode, useRef } from 'react';
import {
  IntercomArticle,
  useLaunchIntercomArticle,
} from '../../config/intercom';
import { BaseButton } from '../button/base-button';
import './help.css';

interface IntercomHelpProps {
  description?: string;
  articleId: IntercomArticle;
  onLaunchArticle?: () => void;
  children?: ReactNode;
  linkStyle?: CSSProperties;
}

const IntercomHelp = (props: IntercomHelpProps): ReactElement => {
  const { articleId, description, children, linkStyle, onLaunchArticle } =
    props;

  const buttonRef = useRef<HTMLIonButtonElement>(null);
  const launchIntercomArticle = useLaunchIntercomArticle();

  return (
    <IonRouterLink
      style={linkStyle}
      onClick={() => {
        if (onLaunchArticle) {
          onLaunchArticle();
        }
        launchIntercomArticle(articleId);
      }}
    >
      <div className="help-button-wrapper">
        {children ?? (description && <IonText>{description}</IonText>)}
        <BaseButton
          ref={buttonRef}
          className="help-button"
          buttonProps={{
            fill: 'clear',
            style: linkStyle,
          }}
        >
          <IonIcon icon={helpCircleOutline} />
        </BaseButton>
      </div>
    </IonRouterLink>
  );
};

export { IntercomHelp };
